import {Injectable} from "@angular/core";

@Injectable()
export class UtilityService {
    
    public SaveDownload(file: Blob, defaultFilename?: string) {
        let url = URL.createObjectURL(file);
        let tag = document.createElement('a');
        tag.href = url;
        if (defaultFilename) {
            tag.download = defaultFilename;
        }
        document.querySelector('body').append(tag);
        tag.click();
        setTimeout(() => tag.remove(), 100);
    }
}